const defaultObject = {};

export default defaultObject;
